import React, { useEffect, useState } from 'react'
import Layout from '../../components/common/pageLayout'
import { toast } from 'react-toastify'
import ApplicationsList from '../../components/Leave/Applications'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import constant from '../../constant'
import { v4_change_leave_application_staus, v4_leave_applications } from '../../actions/v4/leave'
import { v3_delete_leave_application } from '../../actions/v3/leave'
import moment from 'moment';
import ExportColumnModal from '../../components/common/ExportColumnModal';
import RecordListFilters from '../../components/common/RecordListFilters';
import { exportRowsToExcel, getLoggedInUserRoleId, replacePageState } from '../../utils';
import { hasPermission } from '../../utils/hasPermission';
const List = (props) => {

    const location = useLocation();
    const { page } = location.state || {};
    const [data, setData] = useState(null)
    const [currentPage, setCurrentPage] = useState(page ? page : 1)
    const [limit, setLimit] = useState(10)
    const [refresh, setRefresh] = useState(false)
    const [filters, setFilters] = useState({ fromDate: '', toDate: '', userId: '', subject: '' });
    const [isExporting, setIsExporting] = useState(false);
    const isAdmin = Number(getLoggedInUserRoleId()) === 1;
    const canEditLeaveApplications = isAdmin || hasPermission(constant.actionPermission.leaveEditApplication);
    const exportColumns = [
        { key: 'name', label: 'Employee Name', value: item => item.EMPLOYEE_NAME || item.FULL_NAME },
        { key: 'location', label: 'Location', value: item => item.LOCATION_NAME },
        { key: 'leaveType', label: 'Leave Type', value: item => item.LEAVE_TYPE_NAME },
        { key: 'fromDate', label: 'From Date', value: item => item.LEAVE_FROM },
        { key: 'toDate', label: 'To Date', value: item => item.LEAVE_TO },
        { key: 'days', label: 'Total Days', value: item => item.TOTAL_DAYS },
        { key: 'subject', label: 'Subject / Note', value: item => item.NOTE },
        { key: 'status', label: 'Status', value: item => item.STATUS },
        { key: 'remarks', label: 'Remarks', value: item => item.REMARKS },
    ];


    useEffect(() => {
        v4_leave_applications(currentPage, limit, filters).then((res) => {
            if (res.status) {
                setData(res.result);
                replacePageState(props.history, constant.Authedcomponent.leaveApplications.url, {
                    page: currentPage // Replace 'yourData' with the data you want to pass
                });
            }
            else {
                toast.error(res.error)
            }
        })
    }, [currentPage, limit, refresh, filters])

    const updateFilters = (nextFilters) => {
        setCurrentPage(1);
        setFilters(nextFilters);
    };

    const exportLeaves = async (selectedColumns = exportColumns) => {
        try {
            setIsExporting(true);
            const rows = [];
            let exportPage = 1;
            while (true) {
                const res = await v4_leave_applications(exportPage, 200, filters);
                if (!res?.status) throw new Error(res?.error || 'Unable to export leave applications.');
                const pageRows = res.result?.leaves || [];
                rows.push(...pageRows);
                if (pageRows.length < 200) break;
                exportPage += 1;
            }
            if (!rows.length) return toast.warn('No leave applications to export.');
            exportRowsToExcel({ rows, columns: selectedColumns, sheetName: 'Leave Applications', fileName: `Leave_Applications_${moment().format('YYYYMMDD_HHmmss')}.xlsx` });
        } catch (error) {
            toast.error(error?.message || 'Unable to export leave applications.');
        } finally {
            setIsExporting(false);
        }
    };

    const changeApplicationStatus = (leaveId, status, remark = '') => {
        v4_change_leave_application_staus({ status, remark }, leaveId).then((res) => {
            if (res.status) {
                toast.success(res.result?.message || 'Status updated successfully');
                // Refresh data after status change
                setRefresh(!refresh)
            } else {
                toast.error(res.error || 'Failed to update status');
            }
        }).catch((err) => {
            toast.error('Error occurred while changing status');
        });
    };

    const deleteLeave = async (leaveId) => {
        if (!window.confirm('Delete this leave application? This cannot be undone.')) return;
        const res = await v3_delete_leave_application(leaveId);
        if (res.status) {
            toast.success(res.result?.message || 'Leave application deleted.');
            setRefresh(!refresh);
        } else toast.error(res.error || 'Unable to delete leave application.');
    };

    return (
        <Layout
            title={'Leave Applications'}
        >
            <RecordListFilters value={filters} onChange={updateFilters} subjectLabel="Leave type / note" />
            <div className="d-flex justify-content-end mb-3">
                <button className="btn btn-sm btn-primary" type="button" data-bs-toggle="modal" data-bs-target="#leave-application-export-columns-modal" disabled={isExporting}>
                    <i className={`mdi ${isExporting ? 'mdi-loading mdi-spin' : 'mdi-file-excel-outline'} label-icon`} /> {isExporting ? 'Exporting...' : 'Export'}
                </button>
            </div>
            {data && <ApplicationsList
                limit={limit}
                data={data}
                changeApplicationStatus={changeApplicationStatus}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                isAdmin={isAdmin}
                canEditApplications={canEditLeaveApplications}
                onDelete={deleteLeave}
            />}
            <ExportColumnModal modalId="leave-application-export-columns-modal" title="Select Leave Columns" columns={exportColumns} onExport={exportLeaves} isExporting={isExporting} />
        </Layout>
    )
}

export default List
